// This file is automatically generated by scripts/build-corejs3-shipped-proposals.mjs

export default new Set<string>([
  "esnext.suppressed-error.constructor",
  "esnext.array.from-async",
  "esnext.array.group",
  "esnext.array.group-to-map",
  "esnext.data-view.get-float16",
  "esnext.data-view.set-float16",
  "esnext.iterator.constructor",
  "esnext.iterator.drop",
  "esnext.iterator.every",
  "esnext.iterator.filter",
  "esnext.iterator.find",
  "esnext.iterator.flat-map",
  "esnext.iterator.for-each",
  "esnext.iterator.from",
  "esnext.iterator.map",
  "esnext.iterator.reduce",
  "esnext.iterator.some",
  "esnext.iterator.take",
  "esnext.iterator.to-array",
  "esnext.json.is-raw-json",
  "esnext.json.parse",
  "esnext.json.raw-json",
  "esnext.math.f16round",
  "esnext.promise.try",
  "esnext.symbol.async-dispose",
  "esnext.symbol.dispose",
  "esnext.symbol.metadata",
]);
